// handles "View More" buttons
export default function initViewMore() {
  const viewMoreList = document.getElementById("view-more--list");
  const viewMoreControls = document.getElementById("view-more--controls");
  const viewMoreButton = document.getElementById("view-more--button");
  const viewMorePostCount = document.getElementById("view-more--post-count");
  const viewMoreTotalPosts = document.getElementById("view-more--total-posts");

  if (viewMoreList) {
    console.cclog("view more???", {
      viewMoreList,
      viewMoreButton,
      viewMorePostCount,
      viewMoreTotalPosts,
    });

    viewMoreButton.addEventListener("click", async function () {
      viewMoreButton.disabled = true;
      const { postType, totalPosts } = viewMoreList.dataset;
      const per_page = Number(viewMoreList.dataset.perPage);
      const pageNum = Number(viewMoreList.dataset.pageNum);
      const currentPostCount = Number(viewMoreList.dataset.currentPostCount);
      const exclude = JSON.parse(viewMoreList.dataset.exclude);

      const page = Number(pageNum) + 1;

      const $otherParams = {};
      if (viewMoreList.dataset.cat) {
        $otherParams.categories = viewMoreList.dataset.cat;
      }
      if (viewMoreList.dataset.category__not_in) {
        $otherParams.categories_exclude = viewMoreList.dataset.category__not_in;
      }
      if (viewMoreList.dataset.s) {
        $otherParams.search = viewMoreList.dataset.s;
      }
      if (viewMoreList.dataset.tag_id) {
        $otherParams.tags = viewMoreList.dataset.tag_id;
      }
      if (viewMoreList.dataset.tag__not_in) {
        $otherParams.tags_exclude = viewMoreList.dataset.tag__not_in;
      }
      if (viewMoreList.dataset.order) {
        $otherParams.order = viewMoreList.dataset.order;
      }
      if (viewMoreList.dataset.orderby) {
        $otherParams.order = viewMoreList.dataset.orderby;
      }

      // TODO: think about making a new endpoint to trim this down to one request
      const newPostsResponse = await fetch(
        `/wp-json/wp/v2/${postType}?${new URLSearchParams({
          ...$otherParams,
          page,
          per_page,
          exclude,
        })}`
      );
      const newPosts = await newPostsResponse.json();

      const renderedBlocks = await Promise.all(
        newPosts.map(async (post) => {
          const response = await fetch(
            `/wp-json/wp/v2/block-renderer/champlain-core/card?${new URLSearchParams(
              {
                name: "champlain-core/card",
                context: "edit",
                post_id: post.id,
              }
            )}`,
            {
              headers: {
                "X-WP-Nonce": wpApiSettings.nonce,
              },
            }
          );

          const { rendered } = await response.json();

          return rendered;
        })
      );

      viewMoreList.dataset.pageNum = page;
      viewMoreList.dataset.currentPostCount =
        currentPostCount + renderedBlocks.length;

      viewMorePostCount.textContent = viewMoreList.dataset.currentPostCount;

      renderedBlocks.forEach((block) =>
        $(block).insertBefore(viewMoreControls)
      );

      console.cclog(viewMoreList.dataset);
      viewMoreButton.disabled =
        viewMoreList.dataset.currentPostCount === totalPosts;
    });
  }
}
